import React from "react";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import CodeEditor from "@uiw/react-textarea-code-editor";
import userReducer from "../../../../../redux/reducers/userReducer";
import {
  getAllApiTokens,
  generateApiAccessToken,
} from "../../../../../redux/actions/auth";

const ApiInfoModal = () => {
  const dispatch = useDispatch();
  const userDeviceId = useSelector((state) => state.skillReducer.draftSession);
  const _skillInfo = useSelector((state) => state.skillReducer.helper);
  const userId = useSelector((state) => state.userReducer?.user?.sub);
  const userToken = useSelector(
    (state) => state.authReducer?.allTokensList[0]?.token ?? "YOUR_API_TOKEN"
  );
  const [code, setCode] = useState();
  const [genAICode, setGenAICode] = useState();

  useEffect(() => {
    checkAndCreateToken();
  }, []);

  const checkAndCreateToken = async () => {
    let allTokens = await dispatch(getAllApiTokens());
    if (allTokens.length === 0) {
      console.log("Token Not Found");
      let _createtoken = await dispatch(generateApiAccessToken());
      if (_createtoken) {
        console.log("Token Created");
        dispatch(getAllApiTokens());
      } else {
        console.log("Token Not Created");
      }
    }
  };
  useEffect(() => {
    let _cmd = `curl -L -X POST "${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/external/execute" -H "X-API-TOKEN:${userToken}" -H "X-API-ORG: ${_skillInfo?.organizationId}" -H "Content-Type: application/json" --data-raw "{\"deviceId\": ${userDeviceId},\"skillId\": ${_skillInfo?.id},\"orgId\":  ${_skillInfo?.organizationId},\"bulk\": true,\"isAPI\":true,\"userId\":\"${userId}\",\"restoreChrome\":true,\"type\":\"executeSkill\", \"additionalParams\":{Your input payload goes here}`;
    setCode(_cmd);
    return () => {
      setCode("");
    };
  }, [_skillInfo]);

  const cmdData = `# USE THE BELOW CURL COMMAND TO TRIGGER THE AGENT WITH INPUT FILE

curl -L -X POST "${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/v2/execute/" \
--header 'x-api-token: ${userToken}' \
--header 'x-api-org: ${_skillInfo?.organizationId}' \
--form 'v2AgentId=${_skillInfo?.v2AgentId}' \
--form 'v2SkillId=${_skillInfo?.v2SkillId}' \
--form 'inputFiles=@"/C:/Users/Mritunjay Jha/Downloads/temp_document.docx"' \


# USE THE BELOW CURL COMMAND TO TRIGGER THE AGENT WITH INPUT PAYLOAD

curl -L -X POST "${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/v2/execute/" \
--header 'x-api-token: ${userToken}' \
--header 'x-api-org: ${_skillInfo?.organizationId}' \
--data '{
    "v2AgentId":"cm42n7m0j000ahpqwcwgsvpew",
    "v2SkillId":"dn3xqylt4ncr0i0jywco40fb",
    "inputText":{
       "Agent_Status": "answered"
}
}'

# USE THE BELOW CURL COMMAND TO TRIGGER THE AGENT WITHOYT ANY INPUT PAYLOAD OR FILE

curl -L -X POST "${process.env.REACT_APP_BOT_SERVICE_URL}/draftSkills/v2/execute/" \
--header 'x-api-token:${userToken}' \
--header 'x-api-org: 244' \
--form 'v2AgentId=${_skillInfo?.v2AgentId}' \
--form 'v2SkillId=${_skillInfo?.v2SkillId}'
`;

  useEffect(() => {
    let _cmd = cmdData;

    setGenAICode(_cmd);

    return () => {
      setGenAICode("");
    };
  }, [_skillInfo]);

  return (
    <div
      id="apiModal"
      className="modal fade crt-skill"
      role="dialog"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content crt-content">
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
            <h4 className="modal-title">API Info</h4>
          </div>
          <div className="modal-body">
            <div className="form-contain">
              <div className="steps-block">
                {/* <ol>
                  <li>
                    <span>
                      Select post request, paste the URL{" "}
                      <a
                        href="https://teams.microsoft.com/_?culture=en-us&c"
                        target="_blank"
                      >
                        https://teams.microsoft.com/_?culture=en-us&c
                      </a>
                    </span>
                  </li>
                  <li>
                    <span>Select post request, paste the URL</span>
                  </li>
                </ol> */}
              </div>
              <div className="code-block">
                <pre className="scrollable">
                  <CodeEditor
                    readOnly={true}
                    value={
                      _skillInfo?.TEMPLATE === "GenAi Automation"
                        ? genAICode
                        : code
                    }
                    language="js"
                    padding={15}
                    style={{
                      fontSize: 12,
                      backgroundColor: "#f5f5f5",
                      fontFamily:
                        "ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace",
                    }}
                  />
                  <br />
                </pre>
              </div>
              <div className="frm-btns">
                <button className="btn-primary" data-dismiss="modal">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApiInfoModal;
